import { USER } from '../constant/actionTypes';

const getUserRoles = (state, action) => {
  switch (action.type) {
    case USER.ROLE_LIST.SUCCESS:
      return action.payload;
    case USER.ROLE_LIST.ERROR:
      return action.payload;
    default:
      return (typeof state === 'undefined') ? [] : state;
  }
};

export default getUserRoles;
